<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :query-api="vendorQuery"
                                           :ignoreMaxTableItemLimit="true"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPrPriceResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" :query-api="vendorQuery" :ignoreMaxTableItemLimit="true"
                                      :useCustomFieldsDefaultFlag="false"
                                      :ignoreAdd="true" :ignoreDelete="true"
                                      detailInlineButtonType="showAttachmentEntity"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'" editDisable
                                      :importEnabled="true"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length !== 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogFormVisible = true"
                                    >报价
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length !== 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="showProvideHistory()"
                                    >报价历史
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogUpdateTermsTaxRateVisible = true"
                                    >更新条款与税率
                                    </b-button>
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length < 1"
                                        custom-label="上传附件"
                                        :busy="saveAttachmentLoading"
                                        @click="openAttachmentModal">
                                    </em-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="giveUpPrice()"
                                    >放弃报价
                                    </b-button>
                                    <em-button
                                        type="d"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length < 1"
                                        custom-label="上传附件"
                                        :busy="saveAttachmentLoading"
                                        @click="openAttachmentModal">
                                    </em-button>
                                    <em-button
                                        type="export"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled= false
                                        custom-label="导出更新模板" show-name
                                        :busy="exportFile"
                                        @click="exportTemplateFile()">
                                    </em-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="报价信息" :visible.sync="dialogFormVisible">
            <el-form :inline=true>
                <el-form-item label="报价(不含税单价)" required>
                    <el-input v-model="price" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="供货周期(日历日)" label-width="auto" style="margin-left:15px;" required>
                    <div class="block">
                        <el-input-number v-model="supplyCycle" :min="1" label="供货周期"></el-input-number>
                    </div>
                </el-form-item>
                <el-form-item label="税率" required>
                    <el-select filterable style="width:93%;" v-model="taxRate" placeholder="请选择">
                        <el-option
                            v-for="item in taxRateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="币种" required>
                    <el-select filterable style="width:93%;" v-model="moneyType" placeholder="请选择">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="交付条款" required>
                    <el-select filterable style="width:93%;" v-model="deliverItems" placeholder="请选择">
                        <el-option
                            v-for="item in deliverItemOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="有效期(日历日)" required>
                    <el-input v-model="periodValidity" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="remarks" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="offerPrice">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="更新条款与税率" :visible.sync="dialogUpdateTermsTaxRateVisible">
            <el-form :inline=true>
                <el-form-item label="税率" required>
                    <el-select filterable style="width:93%;" v-model="taxRate" placeholder="请选择">
                        <el-option
                            v-for="item in taxRateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="交付条款" required>
                    <el-select filterable style="width:93%;" v-model="deliverItems" placeholder="请选择">
                        <el-option
                            v-for="item in deliverItemOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogUpdateTermsTaxRateVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateTaxRateTerms">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="上传Excel文件"
            :center="true"
            width="30%"
            :visible.sync="dialogBatchVisible">
            <el-form size="small" label-width="80px">
                <el-form-item label="上传">
                    <el-upload
                        ref="upload"
                        :limit="100"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        :auto-upload="false"
                        style="width: 80%;"
                        multiple
                        accept=".xls"
                        :headers="headers"
                        :action="entityBaseUrl+'batchUpdateByExcel'"
                    >
                        <div slot="trigger" class="sith-upload"><i class="el-icon-upload"/> 注意：不允许修改除报价以外的属性！</div>
                        <div slot="tip" class="el-upload__tip">可上传文件不超过20M</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="uploadDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="uploadFile">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
            title="历史报价"
            :center="true"
            :visible.sync="dialogHisPriceVisible">
            <el-table
                :data="tableData"
                height="250"
                border
                style="width: 100%">
                <el-table-column
                    prop="price"
                    label="报价(不含税单价)"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="supplyCycle"
                    label="供货周期(日历日)"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="taxRate"
                    label="税率">
                </el-table-column>
                <el-table-column
                    prop="moneyType"
                    label="币种">
                </el-table-column>
                <el-table-column
                    prop="deliverItems"
                    label="交付条款">
                </el-table-column>
                <el-table-column
                    prop="payItems"
                    label="付款条款">
                </el-table-column>
                <el-table-column
                    prop="periodValidity"
                    label="有效期(日历日)">
                </el-table-column>
                <el-table-column
                    prop="offerPriceTime"
                    label="日期时间">
                </el-table-column>
            </el-table>
        </el-dialog>

        <ReBModal header="上传附件"
                  @ok="submitAttachmentChange"
                  ref="uploadAttachment">
            <multi-attachment class="w-100"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-06-25 10:35:42

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import {
    getOptionsDeliverTerms,
    getOptionsPaymentTerms,
    getOptionsTaxRates
} from "@/model/sithMes/stool/TermsAndTaxRate.js";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";

export default {
    name: "sithMesStoolPrPriceListView",
    components: {MiniButton, MultiAttachment, ReBModal},
    mixins: [emCommonListMixin, emCommonApiMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            exportFile:false,
            dialogFormVisible: false,
            dialogUpdateTermsTaxRateVisible: false,
            dialogBatchVisible: false,
            dialogHisPriceVisible: false,
            saveAttachmentLoading: false,
            price: 0,
            vendorQuery: 'findByVendor',
            moneyType: 'CNY',
            attachmentIds: '',
            taxRate: 'JK',
            tableData: [],
            taxRateList: getOptionsTaxRates(),
            supplyCycle: 1,
            periodValidity: 60,
            deliverItems: 'DDP',
            deliverItemOptions: getOptionsDeliverTerms(),
            payItems: 'A120',
            payItemOptions: getOptionsPaymentTerms(),
            remarks: '',
            options: [
                {
                    label: '人民币/CNY',
                    value: 'CNY'
                },
                {
                    label: '欧元/EUR',
                    value: 'EUR'
                },
                {
                    label: '美元/USD',
                    value: 'USD'
                },
                {
                    label: '英镑/GBP',
                    value: 'GBP'
                },
                {
                    label: '法郎/CFAF',
                    value: 'CFAF'
                },
                {
                    label: '卢比/INR',
                    value: 'INR'
                },
                {
                    label: '澳元/AUD',
                    value: 'AUD'
                },
                {
                    label: '日元/JPY',
                    value: 'JPY'
                },
                {
                    label: '港元/HKD',
                    value: 'HKD'
                }
            ]

        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return 'sithMesStoolPrPrice'
        },
        headers() {
            let headers = {}
            let jwt = localStorage['em_sso_token']
            if (jwt != null) {
                headers['Authorization'] = jwt;
            }
            return headers;
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi('sithMesStoolPrPrice')}/`
        },
        $_rowMaterialKey() {
            return 'matCode';
        }
    },
    methods: {
        exportTemplateFile() {
            let url = `${this.$_emApiMixin_entityBaseApi('sithMesStoolPrPrice')}`+'/export/prTemplate';
            const queryForm = this.$store.state[this.modelName].filter;
            let qq = JSON.stringify(queryForm, function (key,value) {
                if(value =='') {
                    return null;
                }
                return value;})
            this.$store.dispatch("api/postReportDownload", {
                url: url,
                data: JSON.parse(qq),
            }, {root: true})
                .then(res => {
                    let blob = new Blob([res], {
                        type: `application/zip;charset-UTF-8`
                    });
                    let objectURL = URL.createObjectURL(blob);
                    let downEle = document.createElement('a');
                    downEle.href = objectURL;
                    downEle.setAttribute('download', 'pr更新模板_'+new Date().getTime()+'.xlsx');
                    downEle.click();
                    this.exportLoading = false;
                })
        },
        offerPrice() {

            this.dialogFormVisible = false;

            if (!this.price || !this.moneyType || !this.deliverItems || !this.supplyCycle || !this.periodValidity) {
                commonViewsUtil.showWarning(this, "请输入必填项！")
                return;
            }

            let row = this.$store.state[this.modelName].entity;
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_SITHMES_STOOL_URL + "/sithMesStoolPrPrice/selective",
                entity: {
                    id: row.id,
                    price: this.price,
                    moneyType: this.moneyType,
                    taxRate: this.taxRate,
                    deliverItems: this.deliverItems,
                    periodValidity: this.periodValidity,
                    remark: this.remarks,
                    supplyCycle: this.supplyCycle
                }
            }).then(() => {
                this.$router.push({name: 'sithMesStoolPrPriceList'});
                //通知sith，报价完成
                let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPrPrice/sendNotification";
                this.$_emApiMixin_post(url, row).then(() => {
                    commonViewsUtil.showSuccess(this, "报价完成！");
                });
                this.$refs.emListFilter.doQuery();
            })
        },
        updateTaxRateTerms() {

            this.dialogUpdateTermsTaxRateVisible = false;

            let ids = this.$store.state['sithMesStoolPrPrice'].checkedItems.join(',');

            this.$_emApiMixin_post(`${this.$_emApiMixin_moduleBaseApi("sithMesStoolPrPrice")}/sithMesStoolPrPrice/updateTaxRateTerms?ids=` + ids, {
                'taxRate': this.taxRate,
                'deliverItems': this.deliverItems
            }).then(response => {
                commonViewsUtil.showSuccess(this, "更新完成！");
                this.$refs.emListFilter.doQuery();
            });
        },
        getDetailInlineButtonType(row) {
            if (row.attachments) {
                return 'showAttachmentEntity';
            }

            return 'showEntity';

        },
        handleChange(file) {
            if (file.size > 20 * 1024 * 1024) {
                this.$message.warning({
                    duration: 10000,
                    message: "文件超过20M，请压缩后再上传"
                });
            }
        },
        handleSuccess(file) {
            this.$refs.upload.clearFiles();
            this.$refs["emListFilter"].doQuery();
        },
        uploadFileDialog() {
            this.dialogBatchVisible = true;
        },
        uploadFile() {
            this.$refs.upload.submit();
            this.dialogBatchVisible = false;
        },
        giveUpPrice() {

            let ids = this.$store.state['sithMesStoolPrPrice'].checkedItems.join(',');

            this.$_emApiMixin_post(`${this.$_emApiMixin_moduleBaseApi("sithMesStoolPrPrice")}/sithMesStoolPrPrice/giveUpPrice?ids=` + ids)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "放弃完成！");
                    this.$refs.emListFilter.doQuery();
                });
        },
        showProvideHistory() {

            this.dialogHisPriceVisible = true;

            this.tableData = [];

            let row = this.$store.state[this.modelName].entity;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPrPrice/searchHistoryPriceRecord/" + row.id;
            this.$_emApiMixin_post(url, {})
                .then((result) => {
                    for (let item of result.data.list) {
                        this.tableData.push({
                            'price': item.price,
                            'supplyCycle': item.supplyCycle,
                            'taxRate': item.taxRate,
                            'moneyType': item.moneyType,
                            'deliverItems': item.deliverItems,
                            'payItems': item.payItems,
                            'periodValidity': item.periodValidity,
                            'offerPriceTime': item.offerPriceTime,
                        });
                    }
                    console.log(this.tableData);
                });
        },
        submitAttachmentChange() {
            this.saveAttachmentLoading = true;
            let api = process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment";
            this.$_emApiMixin_put(api, {
                ids: this.$store.state['sithMesStoolPrPrice'].checkedItems,
                attachments: this.attachmentIds === undefined ? "" : this.attachmentIds
            }).then(() => {
                this.$message.success("保存成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.saveAttachmentLoading = false);
        },
        attachmentLoading(val) {
            this.$refs.uploadAttachment.changeLoading(val);
        },
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        openAttachmentModal() {
            this.attachmentIds = this.$store.state[this.modelName].rows.filter(row => this.$store.state[this.modelName].checkedItems.indexOf(row.id) !== -1)[0].attachments;
            this.$refs.uploadAttachment.showModal();
        },
    },
    mounted() {
        this.$refs["emListFilter"].doQuery();
        //let fields = this.$refs['emTable'].$_emCustomVuexMixin_voConfigs;
        //localStorage['em-table-custom-fields-sithMesStoolPrPrice-rows'] = JSON.stringify(fields);
        //this.$refs['emTable'].tableColumnsReload();
    }
};
</script>
